module.exports = __webpack_public_path__ + "img/peacock.816ce9ed.png";